<menu-banner>
    CodeMapper: Login
</menu-banner>

<section class="center-content">
    <div *ngIf="pleaseLogin">Please login:</div>
    <login-form onTheRight></login-form>
</section>